import { ceilMeasure } from '@utils';
import React, { FC, useMemo } from 'react';
import { Accept, Cancel } from '../../svgs';

interface AcceptOfferedTimeButtonsProps {
  height: number;
  onAcceptTime: () => void;
  onCancel: () => void;
}

export const AcceptOfferedTimeButtons: FC<AcceptOfferedTimeButtonsProps> = ({ height, onAcceptTime, onCancel }) => {
  const bottom = useMemo(() =>
    height < 40 / ceilMeasure ? 2 : 8
    , [height]);

  return (
    <div
      className="accept-time-buttons"
      style={{ bottom }}
    >
      <Cancel onClick={onCancel} />
      <Accept onClick={onAcceptTime} />
    </div>
  );
};
